import { Consts, combineReducers } from '../../../dependencies';

import fetchDashboard from './fetchDashboard';

const { FETCH } = Consts.apiTypes;

export const dashboard = combineReducers({
    [FETCH]: fetchDashboard,
});
